import * as Yup from "yup";

const licensesCountRange = {
  min: 1,
  max: 5000000,
};

const requestPackLicensesCount = Yup.number()
  .required("Number of Licenses is required")
  .min(licensesCountRange.min, "Please enter a number larger than 0")
  .max(licensesCountRange.max, `Number of Licenses cannot exceed ${licensesCountRange.max.toLocaleString("en-US")}`);

export const validateLicensesCountInputValue = (input: string) => {
  return /^(0|[1-9]\d*)$/.test(input) || input === "";
};

export const packRequestValidationSchema = Yup.object().shape({
  licensesCount: requestPackLicensesCount,
  contactName: Yup.string()
    .trim()
    .required("Contact name is required")
    .max(128, "Contact name cannot exceed 128 characters"),
  contactPhone: Yup.string().trim().required("Contact phone is required").min(13, "Please enter correct phone number"),
});

export const enablePackValidationSchema = (unlimitedLicenses: boolean) => {
  return Yup.object().shape({
    licensesCount: unlimitedLicenses ? Yup.number().nullable().notRequired() : requestPackLicensesCount,
  });
};

export const packTrialRequestValidationSchema = Yup.object().shape({
  licensesCount: requestPackLicensesCount,
});
